import React from 'react';

interface PageHeroProps {
  /** маленький моно-чип над заголовком, напр. "CLUB:CORE · ОБРАЩЕНИЯ" */
  eyebrow: string;
  /** крупный глянцевый заголовок */
  title: string;
  /** подзаголовок под заголовком */
  subtitle?: string;
  /** большой призрачный водяной знак на фоне (англ. слово, апперкейс) */
  ghost?: string;
  /** правый слот — действия (кнопки/поиск) */
  children?: React.ReactNode;
}

/**
 * Единая премиум-шапка портала Club:Core ("Aurora").
 * Повторяет приём админского заголовка: глянцевый анимированный текст,
 * ghost-watermark, grid-текстура и бегущий блик (классы .cc-hero* из index.css).
 */
const PageHero: React.FC<PageHeroProps> = ({ eyebrow, title, subtitle, ghost, children }) => (
  <section className="cc-hero p-6 md:p-8">
    {ghost ? <div className="cc-hero-ghost">{ghost}</div> : null}
    <div className="relative z-10 flex flex-wrap items-center justify-between gap-6">
      <div className="min-w-[240px] flex-1">
        <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-line bg-fill-2 px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-[0.14em] text-[#bcc8ff]">
          {eyebrow}
        </span>
        <h1 className="cc-hero-title">{title}</h1>
        {subtitle ? (
          <p className="mt-3 max-w-xl text-sm md:text-base text-fg-secondary">{subtitle}</p>
        ) : null}
      </div>
      {children ? (
        <div className="flex w-full max-w-md flex-shrink-0 items-center gap-2.5 md:w-auto">{children}</div>
      ) : null}
    </div>
  </section>
);

export default PageHero;
